import { DependencyList, useEffect, useRef } from 'react';

export const useAsyncEffect = (
  callback: () => Promise<void>,
  deps: DependencyList,
  once = false,
): void => {
  const isCalled = useRef(false);
  useEffect(() => {
    if (once && isCalled.current) return;
    isCalled.current = true;
    const f = async () => callback();
    f();
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
};
